import { cn } from '@bazaar-marketplace/utils';
import { Slot } from '@radix-ui/react-slot';
import type { FC } from 'react';

import type { BadgeProps } from './types';
import { badgeVariants } from './variants';

export const Badge: FC<BadgeProps> = ({ className, variant, asChild = false, ...props }) => {
  const Comp = asChild ? Slot : 'span';

  return <Comp className={cn(badgeVariants({ variant }), className)} data-slot="badge" {...props} />;
};
